import { useLocationFeatureSwitch } from '@frontend/payments-hooks';
import { SwitchField } from '@frontend/design-system';
import * as styles from '../../../components/Settings/styles/payment-settings-page.styles';

export type IdentifierToggleProps = {
  name: string;
  label: string;
  switchProps: ReturnType<typeof useLocationFeatureSwitch>['featureSettingSwitchProps'];
};

export const IdentifierToggle = ({ name, label, switchProps }: IdentifierToggleProps) => {
  return (
    <div css={styles.ffToggleContainer}>
      <div css={styles.ffToggleLine}>
        <SwitchField
          name={name}
          label={label}
          labelPlacement='left'
          css={styles.ffSwitch()}
          {...switchProps}
          disabled={switchProps.disabled}
        ></SwitchField>
      </div>
    </div>
  );
};
